// @flow
import React from 'react';
import type {Node} from 'react';
import {HabitScheduleV2} from 'modules/habits/v2/components';

export const HabitScheduleTabContent = (): Node => {
  return <HabitScheduleV2 />;
};
